<template>
  <div id="subpage" v-loading="loading">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>单页管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item to="/signle/index">新闻单页</el-breadcrumb-item>
        <el-breadcrumb-item>添加单页</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <span class="title">添加单页</span>
      </div>
      <div class="xcx-content">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          style="width: 80%"
        >
          <el-form-item label="标题：" prop="title">
            <el-col :span="20">
              <el-input placeholder="请填写中文标题" v-model="ruleForm.title"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="详情：" prop="content">
            <vue-ueditor-wrap
              @before-init="beforeInit"
              v-model="ruleForm.content"
              :config="config"
              ref="ueditor"
              @ready="ready"
            ></vue-ueditor-wrap>
          </el-form-item>
          <el-form-item>
            <div style="width: 100%; height: 15px"></div>
            <el-button type="primary" @click="submitForm('ruleForm')" v-if="id">确认修改</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')" v-else>确认添加</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import BaseEditor from "../../components/editer/Editer";
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  props: ["isEdit"],
  components: {
    BaseEditor,
    VueUeditorWrap,
  },
  data() {
    return {
      loading: true,
      id: "",
      content: "",
      ruleForm: {
        title: "",
        content: "",
      },
      rules: {
        title: [{ required: true, message: "请输入标题名称", trigger: "blur" }],
        content: [{ required: true, message: "请填写详情", trigger: "blur" }],
      },
      config: {
        // 相对路径
        UEDITOR_HOME_URL: "/UEditor/",
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度// 初始容器宽度
        initialFrameHeight: 300,
        initialFrameWidth: "100%",
        toolbars: [
          [
            "fullscreen",
            "source",
            "|",
            "undo",
            "redo",
            "|",
            "bold",
            "italic",
            "underline",
            "fontborder",
            "strikethrough",
            "superscript",
            "subscript",
            "removeformat",
            "formatmatch",
            "blockquote",
            "pasteplain",
            "|",
            "forecolor",
            "backcolor",
            "insertorderedlist",
            "insertunorderedlist",
            "selectall",
            "cleardoc",
            "|",
            "rowspacingtop",
            "rowspacingbottom",
            "lineheight",
            "|",
            "customstyle",
            "paragraph",
            "fontfamily",
            "fontsize",
            "|",
            "directionalityltr",
            "directionalityrtl",
            "indent",
            "|",
            "justifyleft",
            "justifycenter",
            "justifyright",
            "justifyjustify",
            "|",
            "touppercase",
            "tolowercase",
            "|",
            "link",
            "unlink",
            "anchor",
            "|",
            "imagenone",
            "imageleft",
            "imageright",
            "imagecenter",
            "|",
            "simpleupload",
            "insertimage",
            "|",
            "horizontal",
            "date",
            "time",
            "spechars",
            "snapscreen",
            "|",
            "inserttable",
            "deletetable",
            "insertparagraphbeforetable",
            "insertrow",
            "deleterow",
            "insertcol",
            "deletecol",
            "mergecells",
            "mergeright",
            "mergedown",
            "splittocells",
            "splittorows",
            "splittocols",
            "charts",
          ],
        ],
        // 不显示字数
        // wordCount: false,
        enableAutoSave: true, //自动保存
        // 上传图片路径,需要后台配置，否则控制台会报错。
        // 报错信息为 后台配置项返回格式出错，上传功能将不能正常使用！
        serverUrl: "https://api.iztrv.com/laravel-u-editor-server/server",
      },
    };
  },

  /**
   * 进入页面加载
   */
  mounted() {
    var that = this;
    var query = that.$route.query;
    if (query.id) {
      that.id = query.id;
      that.getDetail();
    }
    // that.getCate();
    that.loading = false;
  },
  methods: {
    ready(e) {
      console.log(e);
    },

    beforeInit(e) {
      console.log(e);
    },
    /**
     * 获取详情
     */
    getDetail() {
      var that = this;
      that.axios.post("/single/edit", { id: that.id }).then((res) => {
        if (res) {
          that.ruleForm = res.data;
          if (res.data.tags) {
            var positionIds = res.data.tags.split(",");
            var arrPositionIds = [];
            for (var arrInt in positionIds) {
              arrPositionIds.push(parseInt(positionIds[arrInt]));
            }
            that.ruleForm.tags = arrPositionIds;
          } else {
            that.ruleForm.tags = [];
          }
        }
      });
    },
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.ruleForm;
        var url = "/single/store";
        if (that.id) {
          formData.id = that.id;
          url = "/single/update";
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.$router.push("/single/index");
        });
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * 返回
     */
    back() {
      this.$router.push("/single/index");
    },
  },
};
</script>
<style>
.edui-default {
  line-height: 20px;
}
.line {
  text-align: center;
}
</style>